import { render, staticRenderFns } from "./RankingK4.vue?vue&type=template&id=29d55257"
import script from "./RankingK4.vue?vue&type=script&lang=js"
export * from "./RankingK4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports